import { buildJoinUrl } from "../config/appConfig";
import { readStoredTier } from "./packageTier";

const AUTH_USER_KEY = "synergycoin:authUser";

const computeReferralUrlInternal = (user) => {
  if (!user || typeof user !== "object") return undefined;

  const candidates = [user.referralUrl, user.refLink];
  for (const candidate of candidates) {
    if (typeof candidate === "string" && candidate.trim()) {
      return candidate.trim();
    }
  }

  const code = typeof user.referralCode === "string" ? user.referralCode.trim() : user.referralCode;
  if (code) {
    const normalizedCode = `${code}`.trim().replace(/^\/+/, "");
    if (normalizedCode) {
      return buildJoinUrl(normalizedCode);
    }
  }

  return undefined;
};

const mergeStoredTier = (user, userId) => {
  if (!userId) {
    return user;
  }
  const storedTier = readStoredTier(userId);
  if (storedTier === null) {
    return user;
  }
  const numericTier = Number(user?.packageTier);
  if (Number.isFinite(numericTier) && numericTier >= storedTier) {
    return user;
  }
  return {
    ...user,
    packageTier: storedTier,
  };
};

const prepareUserForStorage = (user) => {
  if (!user || typeof user !== "object") return user;

  const referralUrl = computeReferralUrlInternal(user);
  const resolvedId =
    typeof user.id === "string" && user.id
      ? user.id
      : typeof user._id === "string" && user._id
        ? user._id
        : undefined;

  const base = resolvedId ? { ...user, id: resolvedId } : { ...user };
  const baseWithTier = mergeStoredTier(base, resolvedId);

  if (!referralUrl) {
    return baseWithTier;
  }

  return {
    ...baseWithTier,
    referralUrl,
  };
};

export const computeReferralUrl = (user) => computeReferralUrlInternal(user);

export const saveAuthUser = (user) => {
  try {
    const payload = prepareUserForStorage(user);
    localStorage.setItem(AUTH_USER_KEY, JSON.stringify(payload));
  } catch (error) {
    console.error("Failed to store auth user", error);
  }
};

export const getAuthUser = () => {
  try {
    const stored = localStorage.getItem(AUTH_USER_KEY);
    if (!stored) {
      return null;
    }

    const parsed = JSON.parse(stored);
    return prepareUserForStorage(parsed);
  } catch (error) {
    console.error("Failed to parse stored auth user", error);
    return null;
  }
};

export const clearAuthUser = () => {
  try {
    localStorage.removeItem(AUTH_USER_KEY);
  } catch (error) {
    console.error("Failed to clear auth user", error);
  }
};
